import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TrackingIdService {
  private readonly storageKey = 'sf_tracking_id';
  private memoryId: string | null = null;

  public getOrCreateTrackingId(): string {
    const stored = this.getStoredId();
    if (stored) return stored;

    const generated = this.generateId();
    if (this.canUseStorage()) {
      try {
        localStorage.setItem(this.storageKey, generated);
        return generated;
      } catch {
        this.memoryId = generated;
        return generated;
      }
    }

    this.memoryId = generated;
    return generated;
  }

  private getStoredId(): string | null {
    if (this.memoryId) return this.memoryId;
    if (!this.canUseStorage()) return null;
    try {
      const stored = localStorage.getItem(this.storageKey);
      return stored && stored.length > 0 ? stored : null;
    } catch {
      return null;
    }
  }

  private canUseStorage(): boolean {
    return typeof window !== 'undefined' && typeof localStorage !== 'undefined';
  }

  private generateId(): string {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
      return crypto.randomUUID();
    }

    if (typeof crypto !== 'undefined' && typeof crypto.getRandomValues === 'function') {
      const bytes = new Uint8Array(16);
      crypto.getRandomValues(bytes);
      bytes[6] = (bytes[6] & 0x0f) | 0x40;
      bytes[8] = (bytes[8] & 0x3f) | 0x80;
      const toHex = (byte: number) => byte.toString(16).padStart(2, '0');
      return [
        Array.from(bytes.slice(0, 4)).map(toHex).join(''),
        Array.from(bytes.slice(4, 6)).map(toHex).join(''),
        Array.from(bytes.slice(6, 8)).map(toHex).join(''),
        Array.from(bytes.slice(8, 10)).map(toHex).join(''),
        Array.from(bytes.slice(10, 16)).map(toHex).join(''),
      ].join('-');
    }

    return `sf_${Math.random().toString(36).slice(2)}${Date.now().toString(36)}`;
  }
}
